module.exports = __webpack_public_path__ + "img/og.3b573e20.png";